<template>
    <div class="confirmation-page d-flex align-items-center justify-content-center min-vh-100 p-3">
        <div class="container my-5 p-0 rounded-4 shadow-lg bg-dark text-light border-success overflow-hidden main-card">

            <!-- Encabezado de Éxito (Inspirado en el Banner) -->
            <div class="header-banner text-center py-5 px-3">
                <div class="date-badge mb-3">12 • JUL • 2026</div>
                <h1 class="titulo-display display-4 text-uppercase mb-0">¡Registro Recibido!</h1>
                <p class="text-uppercase tracking-widest opacity-75">XHIDENXHI - Quinta Edición</p>
            </div>

            <div class="content-body p-4 p-md-5">
                <div class="row justify-content-center text-center">
                    <div class="col-lg-8">

                        <!-- Sección de Folio -->
                        <div class="folio-section mb-5 py-4 px-3 rounded-4">
                            <p class="text-uppercase fw-bold mb-1 text-success tracking-wider">Número de Folio
                                Provisional</p>
                            <div class="display-1 fw-bold num-folio mb-2">{{ String($route.params.numeroCorredor).padStart(4, '0') }}</div>
                            <div class="badge bg-warning text-dark px-3 py-2 rounded-pill fw-bold">
                                ⚠️ VALIDACIÓN DE PAGO PENDIENTE
                            </div>
                        </div>

                        <!-- Bloque de Información -->
                        <div class="info-card bg-black-50 p-4 rounded-4 border border-secondary mb-5 text-start">
                            <h5 class="text-success fw-bold mb-3">
                                <i class="bi bi-info-circle-fill me-2"></i>Confirmación:
                            </h5>
                            <p class="mb-0 lh-lg">
                                Los organizadores revisarán tu comprobante para asignarte tu <strong>número de corredor
                                    oficial</strong>.
                                Nos pondremos en contacto contigo a la brevedad para confirmar la recepción y asegurar
                                tu lugar en la línea de salida.
                            </p>
                            <div class="alert alert-danger mt-4 border-0 bg-danger-subtle text-danger-emphasis">
                                <strong>NOTA:</strong> Tu registro quedará pendiente si el pago no coincide con los
                                datos proporcionados
                                o fue realizado de forma incorrecta.
                            </div>
                        </div>

                        <!-- Sección WhatsApp con estilo de botón redondeado -->
                        <div class="whatsapp-section mb-2">
                            <h5 class="text-uppercase fw-bold mb-3 tracking-wider">Tu Foto de Corredor:</h5>
                            <p class="opacity-75 mb-4">
                                Una vez que confirmemos tu registro oficial, envíanos una foto tuya realizando actividad
                                física o corriendo para tu ficha de corredor:
                            </p>

                            <div class="reto-container-wrapper mx-auto" style="max-width: 350px;">
                                <a href="https://wa.me/525540861907" target="_blank"
                                    class="btn custom-btn w-100 d-flex align-items-center justify-content-center gap-2">
                                    <span class="fs-4">📞</span>
                                    <span class="fw-bold">5540861907</span>
                                </a>
                            </div>

                            <div class="mt-4">
                                <div class="btn-regresar-wrapper mx-auto" @click="regresar" style="cursor: pointer;">
                                    <button
                                        class="btn btn-link text-light text-decoration-none text-uppercase fw-bold w-100 py-2">
                                        <i class="bi bi-arrow-left me-2"></i>Volver al Inicio
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <!-- Footer decorativo -->
            <div class="bg-success py-3 text-center">
                <small class="text-uppercase fw-bold text-dark tracking-widest">Nos vemos en el barro<br>XHIDENXHI
                    2026</small>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

const regresar = () => {
  router.replace('/carrera-obstaculos-julio-2026')
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Staatliches&family=Roboto:wght@400;700&display=swap');

.confirmation-page {
    background: linear-gradient(180deg, rgba(26, 62, 51, 0.8), rgba(0,0,0,0.9));
    max-height: max-content;
    margin-bottom: -50px;
}

.main-card {
  border-top: 6px solid #2e7d32;
  max-width: 900px;
}

.header-banner {
  background-color: #1a1a1a;
  border-bottom: 1px solid rgba(46, 125, 50, 0.3);
}

.titulo-display {
  font-family: 'Staatliches', cursive;
  letter-spacing: 3px;
  color: #fff;
}

.date-badge {
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 50px;
  padding: 5px 25px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
}

.num-folio {
  font-family: 'Staatliches', cursive;
  color: #2e7d32;
  text-shadow: 0 0 20px rgba(46, 125, 50, 0.4);
}

.folio-section {
  background: rgba(46, 125, 50, 0.05);
  border: 1px dashed rgba(46, 125, 50, 0.5);
}

/* Reutilizando el estilo de cápsula para el botón de WhatsApp */
.reto-container-wrapper {
  border: 2px solid #2e7d32;
  border-radius: 50px;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: transform 0.3s ease;
}

.reto-container-wrapper:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.5);
}

.custom-btn {
  border-radius: 40px !important;
  color: white !important;
  background-color: #2e7d32 !important;
  padding: 15px 0;
  text-decoration: none;
}

.tracking-widest { letter-spacing: 5px; }
.tracking-wider { letter-spacing: 2px; }
.bg-black-50 { background-color: rgba(0,0,0,0.3); }

.lh-lg { line-height: 1.8; }

.btn-regresar-wrapper {
  display: block;
  max-width: 250px;
  border: 1px solid rgba(255, 255, 255, 0.3); /* Borde blanco sutil */
  border-radius: 50px;
  padding: 4px; /* El padding de separación interna */
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-regresar-wrapper:hover {
  border-color: #2e7d32; /* Se vuelve verde al pasar el mouse */
  background-color: rgba(46, 125, 50, 0.1);
  transform: translateY(-2px);
}

.btn-regresar-wrapper button {
  font-size: 0.9rem;
  letter-spacing: 1px;
}
</style>
